import { React, useState, useEffect } from 'react';
import Select from "react-select";
import LeaseApiService from '../../services/apiService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const LeaseDetails = ({ tableLoading, setTransectionData, transectionData, bankList }) => {
    const apiService = new LeaseApiService();

    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            return updatedData;
        });
    };
    const handleDropDownChange = async ({ name, value }) => {
        setTransectionData(prev => ({ ...prev, [name]: value }));
    };
  
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                {/* <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(450px, 1fr))', gap: '20px' }}> */}
                <div className="form-group">
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">Rent Per Anum *</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.rentPerAnum}
                            onChange={handleInputChange} name="rentPerAnum" /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1 start">Rent / Month *</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.rentByMonth} onChange={handleInputChange} name="rentByMonth" /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1 start">Rent per Day</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.rentPerDay} onChange={handleInputChange} name="rentPerDay" /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1">Security Deposit</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.securityDeposit} onChange={handleInputChange} name="securityDeposit" /></div>
                        <div className=" col-1"><h8 className='center p-1'>%</h8></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.securityDepositPerc} onChange={handleInputChange} name="securityDepositPerc" /></div>
                        <div className=" col-2"><label className="form-label pt-1">Calculate %</label></div>
                    </div>
                    <div className="row ">
                        <div className=" col-3"><label className="form-label pt-1">Commission Paid By Tenant</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.tenantCommission} onChange={handleInputChange} name="tenantCommission" /></div>
                        <div className=" col-1"><h8 className='center p-1'>%</h8></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.tenantCommissionPerc} onChange={handleInputChange} name="tenantCommissionPerc" /></div>
                        <div className=" col-2"><label className="form-label pt-1">Calculate %</label></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1">Commission Paid By Landlord</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.landlordCommission} onChange={handleInputChange} name="landlordCommission" /></div>
                        <div className=" col-1"><h8 className='center p-1'>To</h8></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.landlordCommissionPerc} onChange={handleInputChange} name="landlordCommissionPerc" /></div>
                        <div className=" col-2"><label className="form-label pt-1">Calculate %</label></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">Maintenance Fee</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.maintenanceFee} onChange={handleInputChange} name="maintenanceFee" /></div>
                        <div className=" col-1"><h8 className='center p-1'>Due On</h8></div>
                        <div className='col-3'>
                            <DatePicker
                                todayButton="Today"
                                selected={transectionData?.dueDate}
                                onChange={(date) => handleDateChange({ name: 'dueDate', value: date })}
                                dateFormat="dd-MMM-yyyy"
                                className="p-2 form-control w-100"
                            />
                        </div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1 start">No of Installments *</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.installment} onChange={handleInputChange} name="installment" /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">Rent Payable To</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.rentPayable} onChange={handleInputChange} name="rentPayable" /></div>
                        <div className=" col-1"><h8 className='center p-1'>IBAN To</h8></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.IbanNo} onChange={handleInputChange} name="IbanNo" /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1">Sec Deposit Payable To</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.secDepositPayable} onChange={handleInputChange} name="secDepositPayable" /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">Commission Payable To</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.commissionPayable} onChange={handleInputChange} name="commissionPayable" /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1 start">Bank Name</label></div>
                        <div className=" col-3">
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={transectionData?.bankName}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'bankName', value: selectedOption })}
                                options={bankList?.map(country => ({ value: country, label: country?.text }))}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">Account No</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.accountNo} onChange={handleInputChange} name="accountNo" /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1">Fixed Charges</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.fixedCharges} onChange={handleInputChange} name="fixedCharges" /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">Variable Charges</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.variableCharges} onChange={handleInputChange} name="variableCharges" /></div>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default LeaseDetails